import React, { useState } from "react";

import { get } from "lodash";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Spacer from "../../../components/Spacer";
import OutOfView from "../../../components/Lazyload/OutOfView";
import AsyncGet from "../../../components/Materials/AsyncGet";
import { formatTimeAgo } from "../../../helpers/date";
import DeleteNotification from "./DeleteNotification";
import style from './style.module.css';

const Card = ({ item = {}, toggleNotification }) => {
    let timeOut = null;
    const [loadOnMount, setLoadOnMount] = useState(false);
    const onOutHandler = (entry, observer, observerRef) => {
        if (entry.isIntersecting) {
            if (observerRef) {
                observer.disconnect();
                if (get(item, "is_read") === 0) {
                    clearTimeout(timeOut);
                    timeOut = setTimeout(() => {
                        setLoadOnMount(true);
                    }, 3000);
                }
            }
        }
    }

    return (
        <AsyncGet
            attribute="NotificationList"
            url={`/notification/mark-as-read/${get(item, "id")}`}
            method="put"
            loadOnMount={loadOnMount}
            permissionText="Notification Mark As Read"
            onFetch={({ data, updateGridItem }) => {
                if (get(data, "id")) {
                    updateGridItem({ attribute: "NotificationList", data });
                }
            }}
            render={() => {
                return (
                    <OutOfView onOutCallback={onOutHandler}>
                        <label key={get(item, "id")} className={`${style.msgItem}${get(item, "is_read") === 0 ? ` ${style.unread}` : ``}`} onClick={toggleNotification}>
                            <Link to={`/${get(item, "model")}/view/${get(item, 'model_id')}`}>
                                <Spacer />
                                <div className={`${style.content} ${style[get(item, "color", "")]}`}>
                                    <div className={style.cardHeader}>
                                        <Text className={`${style.title} ${style[get(item, "color", "")]}`}>
                                            {get(item, "title")}
                                        </Text>
                                        <DeleteNotification item={item} />
                                    </div>
                                    <Spacer size={8} />
                                    <Text className="size14">{get(item, "text")}</Text>
                                    <Spacer size={8} />
                                    <Text className="size14">{formatTimeAgo(get(item, "created_at"))}</Text>
                                </div>
                                <Spacer />
                            </Link>
                        </label>
                    </OutOfView>
                )
            }}
        />
    )
}
export default Card;

